import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import config from '../../config.json';
import './Category.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
// import { setPosition } from './util/ScrollRestoration';

const Category = ({ _id, name, image, companyId, currencyType }) => {
    const { pathname } = useLocation()
    const navigate = useNavigate();

    return (
        <div onClick={() => {
            // const elementChild = document.getElementById('child_scrollableDiv');
            // setPosition(pathname, elementChild)
            navigate(`${pathname}/archive`, {state: { categoryId: _id, categoryName: name, currencyType, companyId, preventScrollReset: true }})
        }}
            className="category-item rtl"
        >
            <LazyLoadImage
                width={window.innerWidth < 576 ? '140px' : '200px'}
                height={window.innerWidth < 576 ? '84px' : '120px'}
                src={`${config.server_address}/upload/${image}`}
                effect="blur"
            />
            <div><span>{name}</span></div>
            <button>
                <i className='fa fa-shopping-cart'></i>
                <span>مشاهده</span>
                <i className='fa fa-arrow-left'></i>
            </button>
        </div>
    );
}

export default Category;